module.exports = __webpack_public_path__ + "img/portrait_offline.397c9a5c.png";